export default __webpack_public_path__ + "static/media/img4.7cc84a8c.jpg";